import type { ITextObject } from './types/text-object';

export const TEXT_CREATION_TOOL_NAME = 'textCreationTool';

export const TEXT_CREATION_PLACEHOLDER_CONTENT = 'Text';

export const TEXT_CREATION_DEFAULT_TEXT_HEIGHT = 2;

export const TEXT_CREATION_PREVIEW_GUID = '__text-creation-preview__';

export const TEXT_CREATION_DEFAULT_COLOR = '#ffffff';

export function createDefaultTextObject(
  insertionPoint: ITextObject['insertionPoint'],
  guid: string
): ITextObject {
  return {
    guid,
    content: TEXT_CREATION_PLACEHOLDER_CONTENT,
    insertionPoint,
    textHeight: TEXT_CREATION_DEFAULT_TEXT_HEIGHT,
    rotation: 0,
    horizontalAttachment: 'left',
    verticalAttachment: 'top',
    widthFactor: 1,
    obliqueAngle: 0,
    boxWidth: 0,
    lineSpacingFactor: 1,
    lineSpacingStyle: 'atLeast',
    drawDirection: 'leftToRight',
    color: TEXT_CREATION_DEFAULT_COLOR,
    metaData: {
      isColorByLayer: true,
    },
    editable: true,
  };
}

export function createPreviewTextObject(): ITextObject {
  return createDefaultTextObject(
    { x: 0, y: 0, z: 0 },
    TEXT_CREATION_PREVIEW_GUID
  );
}
